import { useSupabaseClient } from "#imports";
import type { SupabaseClient } from "@supabase/supabase-js";
import type { UnwrapRef, Ref } from "vue";
import type { Database } from "~~/types/database.types";

export type GetterType<T extends (...args: any[]) => Ref<any>> = NonNullable<
  UnwrapRef<ReturnType<T>>
>;

export type NullToOptional<T> = {
  [K in keyof T as null extends T[K] ? K : never]?: T[K];
} & {
  [K in keyof T as null extends T[K] ? never : K]: T[K];
};

let supabase: SupabaseClient<Database> | null = null;
export const useSupabase = () => {
  if (!supabase) {
    supabase = useSupabaseClient<Database>();
  }
  return supabase!;
};

export const splitUrlPathIntoParts = (url: string) => {
  if (
    !url.startsWith("http://127.0.0.1:54321/storage/v1/object/public/") &&
    !url.startsWith("https://api.mappr.com/storage/v1/object/public/")
  ) {
    return null;
  }
  const urlPath = url
    .replace("http://127.0.0.1:54321/storage/v1/object/public/", "")
    .replace("https://api.mappr.com/storage/v1/object/public/", "");
  const parts = urlPath.split("/", 2);
  if (parts.length !== 2) {
    return null;
  }

  return {
    bucket: parts[0]!,
    path: parts[1]!,
  };
};

export const getIp = async () => {
  try {
    const ipRes = await $fetch<{ ip: string }>(
      "https://api.ipify.org?format=json",
    );
    return ipRes.ip;
  } catch (e) {
    // fail silently
  }
};
